import { render, staticRenderFns } from "./PlansV2.vue?vue&type=template&id=1810e810&scoped=true&"
import script from "./PlansV2.vue?vue&type=script&lang=js&"
export * from "./PlansV2.vue?vue&type=script&lang=js&"
import style0 from "./PlansV2.vue?vue&type=style&index=0&id=1810e810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810e810",
  null
  
)

export default component.exports